var capitalize = function (str) {
    return str[0].toUpperCase() + str.substring(1);
};
export default capitalize;
